export enum ChangeType {
  None = 0,
  New = 1,
  Edited = 2,
  Deleted = 3
}
